// src/components/AdminWrapper.tsx
import React from 'react';

interface AdminWrapperProps {
  children: React.ReactNode;
}

const AdminWrapper: React.FC<AdminWrapperProps> = ({ children }) => {
  // 🔒 GÜVENLİK: Service Role Key artık gerekli değil
  // Tüm admin işlemler Edge Functions üzerinden yapılıyor
  
  return (
    <div>
      {/* Güvenlik bildirimi */}
      <div className="bg-green-50 border-l-4 border-green-400 p-2 mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-green-700">
              🔒 Güvenli Admin Paneli - Edge Functions ile korunuyor
            </p>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default AdminWrapper;
